import {Injectable} from '@angular/core';
import {TagModel} from "../model/tag.model";
import {TagSummaryModel} from "../model/tagSummary.model";
import {AbstractFindAllService} from "../../../../core/service/v2/service/findAll/abstractFindAll.service";
import {TagRepository} from "../../impl/service/ngrx/tag.repository";
import {TagSummaryDataServiceAdapter} from "../../impl/service/ngrx/tagSummaryDataService.adapter";
import {
    AbstractFindManyPaginatedService
} from "../../../../core/service/v2/service/findmany/abstractFindManyPaginated.service";

@Injectable()
export class TagSummaryPaginatedService extends AbstractFindManyPaginatedService<TagModel, TagSummaryModel> {
    constructor(repository: TagRepository, dataService: TagSummaryDataServiceAdapter) {
        super(repository, dataService);
    }
}
